<template>
  <div id="contenedor-main-obra" class="bkground">
    <v-container fluid>
      <v-card flat class="mb-4 rounded-lg">
        <v-card-text>
          <titulo-tool-bar
            v-if="!$apollo.queries.obra.loading"
            :titulo="getObra.clave"
            nombreRuta="planeacion"
            regresar>
          </titulo-tool-bar>
          <v-tabs>
            <template v-for="(opcion, index) in opciones">
              <v-tab
                :key="index"
                :to="{ name: opcion.ruta }"
                exact>
                {{ opcion.nombre }}
              </v-tab>
            </template>
            <v-tab
              v-if="tieneProyecto"
              :to="rutaProyecto"
              exact>
              Proyecto
            </v-tab>
          </v-tabs>
        </v-card-text>
      </v-card>
      <v-card color="transparent" flat>
        <v-card-text class="pa-0">
          <router-view></router-view>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import OBRA from '@/graphql/querys/administracion/planeacion/obra.gql';
import TituloToolBar from '@/components/TituloToolBar.vue';

export default {
  name: 'MainObra',
  components: {
    TituloToolBar,
  },
  data() {
    return {
      opciones: [
        {
          nombre: 'Generales',
          ruta: 'obra',
          icono: '',
        },
        {
          nombre: 'Documentos Relacionados',
          ruta: 'obraDocumentosRelacionados',
          icono: '',
        },
      ],
    };
  },
  apollo: {
    obra: {
      query: OBRA,
      variables() {
        return {
          id: this.$route.params.idObra,
        };
      },
    },
  },
  computed: {
    getObra() {
      if (!this.obra) return {};
      return this.obra;
    },
    tieneProyecto() {
      return this.obra && this.obra.proyecto && this.obra.proyecto.id;
    },
    rutaProyecto() {
      if (!this.tieneProyecto) return null;
      return {
        name: 'obraProyectos',
        params: {
          idObra: this.$route.params.idObra,
          idProyecto: this.obra.proyecto.id,
        },
      };
    },
  },
};
</script>

<style lang="scss">

</style>
